import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function SabrinaVanCampPage() {
  return <AttorneyBioTemplate attorney={attorneys['sabrina-vancamp-esq']} />;
}
